const DateTimeValidation = [
    /**
     * Determines if is valid in weekdays column
     * @param {Date} dateObject, not string representation
     * @returns {Boolean} whether or not is valid in that column
     */
    function weekdaysDayTime (dateObject) {
        const validDayNumbers = [1, 2, 3, 4, 5];
        const dayNumber = dateObject.getDay();
        const isValidDay = validDayNumbers.includes(dayNumber);
        const time = getTimeString(dateObject);
        const isValidTime = isBetweenTimes("07:00", "17:00", time);
        if(isValidDay && isValidTime) return 'weekdaysDaytime';
        else return null;
    },
    /**
     * 5pm - 12 am monday to friday
     * @param {Date} dateObject 
     * @returns {Boolean}
     */
    function eveningsMondayToFriday (dateObject)  {
        const validDayNumbers = [1, 2, 3, 4, 5];
        const dayNumber = dateObject.getDay();
        const isValidDay = validDayNumbers.includes(dayNumber);
        const time = getTimeString(dateObject);
        const isValidTime = isBetweenTimes("17:00", "24:00", time);
        if(isValidDay && isValidTime) return 'weekdaysEvening';
        else return null;
    },
    /**
     * Returns whether an apt took place between midnight and 7 am
     * @param {Date} dateObject 
     * @returns {Boolean} Whether or not the event took place at night
     */
    function nights (dateObject) {
        const time = getTimeString(dateObject);
        const isValidTime = isBetweenTimes("00:00", "07:00", time);
        if (isValidTime) return 'nights';
        else return null;
    },
    /**
     * Is a weekend (sat or sun) or holiday. Holidays are not yet occounted for
     * when holiday support is enabled, this returning false may be a 
     * pre condition for weekdays daytime/evening
     * @param {Date} dateObject 
     * @returns {Boolean} whether or not the date occurs within a weekndOrHoliday
     */
    function weekendsAndHolidays (dateObject)  {
        const validDayNumbers = [0, 6];
        const dayNumber = dateObject.getDay()
        const isWeekend = validDayNumbers.includes(dayNumber);
        const time = getTimeString(dateObject);
        const isValidTime = isBetweenTimes("07:00", "24:00", time);
        if (isWeekend && isValidTime) return 'weekendOrHoliday';
        else return null;
    },
    // function weekdaysDaytimeSacrifice( dateObject, newApt) {
    //     const isWeekdayDayTime = !!DateTimeValidation[0](dateObject); 
    //     return newApt.sacrificeOfOfficeHours && isWeekdayDayTime;
    // }
];

export const dateTimeValidationObject = {
    nights:DateTimeValidation[2],
    weekendsAndHolidays: DateTimeValidation[3],
    weekdaysDayTime:DateTimeValidation[0],
    weekdaysEvenings:DateTimeValidation[1],
}


/**
 * Converts date from string to Date object
 * @param {string} dateString date as yyyy-mm-dd (with dashes)
 * @param {string} time time in 24 hour format, so 5:24 pm -> '17:24', 12:06 am -> '00:06'
 */
export function convertDate(dateString, time) {
    const newDate = new Date(dateString)
    const timeAtMidnight = newDate.getTime()// milliseconds since 1970

    const hrs = Number(time.substring(0, 2));
    const mins = Number(time.substring(3));
    const msSinceMidnight = hrs * 60 * 60 * 1000 + mins * 60 * 1000;
    const fourHours = 4 * 60 * 60 * 1000; // eastern standard time is 4 hours behind UTC (epoch)

    return (new Date(msSinceMidnight + timeAtMidnight + fourHours)) // the time we mean is the UTC time + 4
}


/**
 * Returns 24 hour string format as "hh:mm", -> 12:06 == "00:06"
 * @param {Date} dateObject 
 * @returns {String} 
 */
function getTimeString(dateObject) {
    let hrString = String(dateObject.getHours());
    let minString = String(dateObject.getMinutes());
    // if single digit, add leading 0
    if(hrString.length == 1){
        hrString= String("0"+hrString) // can never be too sure in a loosely typed language...
    }
    if (minString.length ==1){
        minString = String("0"+minString)
    }
    return(hrString + ":" + minString);
}

/**
 * Determines if a 24 hour string time is between two other 24 hour string times. 
 * @param {string} lowerBound time in 24 hours format, i.e -> "10:45"
 * @param {string} upperBound time in 24 hours format, i.e -> "10:45"
 * @param {string} time time in 24 hours format, i.e -> "10:45"
 * @returns {boolean} Whether or not the value of time is between upper and lower bounds (inclusive)
 */
function isBetweenTimes(lowerBound, upperBound, time) {
    const lowerBoundHour = Number(lowerBound.substring(0, 2));
    const upperBoundHour = Number(upperBound.substring(0, 2));
    const lowerBoundMinute = Number(lowerBound.substring(3));
    const upperBoundMinute = Number(upperBound.substring(3));

    if (upperBoundHour < lowerBoundHour || upperBoundHour == lowerBoundHour && lowerBoundMinute > upperBoundMinute) {
        throw new Error("Invalid times input!");
    }
    const hour = Number(time.substring(0, 2));
    const minute = Number(time.substring(3));

    const lowerBoundValid = (hour > lowerBoundHour || (hour == lowerBoundHour && minute >= lowerBoundMinute));
    const upperBoundValid = (hour < upperBoundHour || (hour == upperBoundHour && minute <= upperBoundMinute));
    return (lowerBoundValid && upperBoundValid);
}


/**
 * Returns which datetime column is appropriate from
 * ['weekdaysDaytime','weekdaysEvening', 'nights', 'weekendOrHoliday']
 * @param {Date} dateObject Time appointment took place
 * @returns {string} The name of the appropriate column for this date time
 */
export function getDateTimeColumn(dateObject){
    // assuming all are mutually exclusive, every dateTime fits in one and only one column;
    const possibleResults = ['weekdaysDaytime','weekdaysEvening', 'nights', 'weekendOrHoliday'];
    for (let i = 0; i < DateTimeValidation.length; i++){
        if (DateTimeValidation[i](dateObject)) return possibleResults[i];
    }
}



/**
 * TESTING THIS FILE
 * WRITE A SCRIPT THAT LOOPS console.log(new Date() - Math.random()*(1e+12) + ',')
 * USE THOSE AS TEST DATES
 * ENSURE EXPECTED NUMBER OF OUTPUTS IS 1 (AS OF NOW)
 */